var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isFvVideo ? 'lds-ring--fv' : 'lds-ring'},[_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }